/* @flow */
import Button from 'components/Button.jsx';
import GroupClusterItem from 'entities/GroupClusterItem';
import GroupClusterItems from 'collections/GroupClusterItems';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import React from 'react';

import './styles/GroupAvatarCluster.scss';

function renderAvatarImage(group) {
  return (
    <Image
      src={group.avatarSvgUrl}
      className="GroupAvatarCluster-avatar"
    />
  );
}

class GroupAvatarCluster extends React.Component {
  static propTypes = {
    groups: React.PropTypes.instanceOf(GroupClusterItems).isRequired,
    maxSize: React.PropTypes.number.isRequired,
    moreButtonHref: React.PropTypes.string,
    onGroupAvatarClick: React.PropTypes.func,
  };

  renderAvatar = (group: GroupClusterItem, index: number) => {
    if (this.props.onGroupAvatarClick) {
      return (
        <Link
          key={index}
          onClick={this.props.onGroupAvatarClick}
          className="GroupAvatarCluster-link"
          eventElementName="GroupAvatarCluster-link">
          {renderAvatarImage(group)}
        </Link>
      );
    } else {
      return (
        <span key={index}>
          {renderAvatarImage(group)}
        </span>
      );
    }
  };

  renderMoreButton = (countNotShown: number) => {
    const bareButton = (
      <Button
        className="GroupAvatarCluster-more"
        level="secondary"
        shape="circle"
        eventElementName="GroupAvatarCluster-more">
        +{countNotShown}
      </Button>
    );

    if (this.props.moreButtonHref) {
      return (
        <Link
          href={this.props.moreButtonHref}
          className="GroupAvatarCluster-link"
          eventElementName="GroupAvatarCluster-link">
          {bareButton}
        </Link>
      );
    } else {
      return bareButton;
    }
  };

  render() {
    const allFit = this.props.groups.length === this.props.maxSize;
    const countToShow = allFit ? this.props.maxSize : this.props.maxSize - 1;
    const groupsToShow = this.props.groups.slice(0, countToShow);
    const countNotShown = this.props.groups.length - countToShow;

    return (
      <div className="GroupAvatarCluster">
        {groupsToShow.map(this.renderAvatar)}
        {countNotShown > 0 && this.renderMoreButton(countNotShown)}
      </div>
    );
  }
}

export default GroupAvatarCluster;



// WEBPACK FOOTER //
// ./src/groups/components/GroupAvatarCluster.jsx